export const removeEmptyeKeys = (obj: Record<string, any>, valuesDiscard: string[] = []): Record<string, any> =>
    Object.keys(obj).reduce((acc: any, key: string) => {
        return {
            ...acc,
            ...(!!obj[key] && !valuesDiscard.includes(obj[key]) ? {[key]: obj[key]} : {}),
        };
    }, {});
